export const SliderConstants = {
  MIN: 0,
  MAX: 100,
  THUMB_SIZE: 28,
  STEP: 1,
};
